<template>
  <h1>404 NOT FOUND</h1>
  <img src="thumbnail.png">
  <br>
  <router-link :to="{ name: 'Home' }">Back to the home page</router-link>
</template>